import React from "react";
import { Box, Spinner } from "native-base";

const ListEmptyState: React.FC = () => {
  return (
    <Box height={300} justifyContent="center" alignItems="center">
      <Spinner />
    </Box>
  );
};

export default React.memo(ListEmptyState);

